<div class="back__navigation">
    <button (click)="onClickBack()"><img src="assets/icons/chevron-left.svg" alt=""><span>{{'back' | translate}}</span></button>
</div>